// extracted by mini-css-extract-plugin
export default {"feature":"location_feature_feature__Oy8S3"};